<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header">
          <div class="row">
            <div class="col">
              <i class="fas fas-align-justify"></i>
              Remedials
            </div>
            <div class="col d-flex justify-content-end">
              <div class="btn btn-primary btn-sm" [routerLink]="['/createremedial']">Create Remedial</div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-5">
              <div class="form-group">
                <input class="form-control" placeholder="Search" [(ngModel)]="searchCriteria.query"
                       (change)="getRemedials()">
              </div>
            </div>
            <div class="col-3">
              <ng-select placeholder="Status"
                         [items]="statuses"
                         bindLabel="name"
                         bindValue="id"
                         [appearance]="'outline'"
                         [(ngModel)]="searchCriteria.status"
                         (change)="getRemedials()"
              ></ng-select>
            </div>
            <div class="col-3">
              <ng-select placeholder="Created By"
                         [items]="users"
                         bindLabel="fullName"
                         bindValue="id"
                         [appearance]="'outline'"
                         [(ngModel)]="searchCriteria.userId"
                         (change)="getRemedials()"
              ></ng-select>
            </div>
            <div class="col-1">
              <button class="btn btn-warning" (click)="clearFilter()">Clear Filter</button>
            </div>
          </div>
          <h3 *ngIf="!remedials.length">No remedials found</h3>

          <div *ngIf="remedials.length">
            <table class="table" [ts-wrapper]="searchCriteria" (sortChange)="this.getRemedials()">
              <thead>
              <tr>
                <th ts-criteria="name">Name</th>
                <th ts-criteria="park">Park</th>
                <th ts-criteria="plot">Plot</th>
                <th ts-criteria="quoteId">Quote</th>
                <th ts-criteria="contractNumber">Contract Number</th>
                <th ts-criteria="status">Status</th>
                <th ts-criteria="createdDate">Date Created</th>
                <th ts-criteria="from365">From 365</th>
                <th ts-criteria="createByUserId">Created By</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let remedial of remedials">
                <td>{{ remedial.name }}</td>
                <td>{{ remedial.park }}</td>
                <td>{{ remedial.plot }}</td>
                <td>
                  <a [routerLink]="['/quotes', remedial.quoteId]">{{ remedial.quoteId }}</a>
                </td>
                <td>{{ remedial.contractNumber }}</td>
                <td>{{ remedial.status }}</td>
                <td>{{ remedial.createdDate | date:'dd/MM/yy HH:mm' }}</td>
                <td [ngClass]="remedial.from365 ? 'text-success' : ''">{{ remedial.from365 ? 'Yes' : 'No' }}</td>
                <td>{{ remedial.createdByUser?.firstName }} {{ remedial.createdByUser?.lastName }}</td>
                <td>
                  <button [routerLink]="['/myremedials', remedial.id]"
                          class="btn btn-ghost-primary">Details
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-xs-12 col-12">
            <div class="d-flex justify-content-center">
              <ngb-pagination [collectionSize]="totalItems"
                              [(page)]="searchCriteria.pageNumber"
                              [pageSize]="searchCriteria.pageSize"
                              [maxSize]="6"
                              [boundaryLinks]="true"
                              (pageChange)="setPage($event)" size="sm"
                              previousLabel="&lsaquo;" nextLabel="&rsaquo;"
                              firstLabel="&laquo;" lastLabel="&raquo;">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
